export default __webpack_public_path__ + "static/media/crashcourse_banner.121f3c95.jpg";